<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title v-if="job.startDate">
      <template v-if="checkJobDateStart(job.startDate, job.endDate)">
        <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span> -
      </template>
      <span>{{ $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMM") }}</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button @click="share()">
        <i class="el-icon-share"></i>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="job_info_wrapper" v-if="job.pharmacy">
        <div class="image_text_comp d-block" @click="userInfoModalOpen()">
          <div class="image_wrapper">
            <el-avatar
              :size="'medium'"
              shape="square"
              :src="job.pharmacy.image"
              v-if="job.pharmacy.image"
            />
            <el-avatar
              :size="'medium'"
              shape="square"
              icon="el-icon-user-solid"
              v-else
            ></el-avatar>
          </div>
          <div class="text_wrapper mt-2">
            <div class="main_text">{{ job.pharmacy.name }}</div>
            <div class="additional_text">
              <span
                >{{ job.pharmacy.address.suburb }},
                {{ job.pharmacy.address.state }}</span
              >
            </div>
          </div>
        </div>
        <div class="info-separator" />

        <div class="rate_shifts_info">
          <div class="info_wrapper d-flex align-items-center">
            <ClockIcon />
            <div class="info_title">Available shifts</div>
            <template v-if="checkJobDateStart(job.startDate, job.endDate)">
              <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span> -
            </template>
            <span>{{
              $moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMMM")
            }}</span>
          </div>
          <div class="info_wrapper d-flex align-items-center">
            <LocationIcon />
            <div class="info_title">
              {{ job.pharmacy.address.suburb }},
              {{ job.pharmacy.address.state }}
            </div>
          </div>
          <div class="info_wrapper d-flex align-items-center">
            <DollarWithCircleIcon />
            <div class="info_title">Hourly rate (excluding super)</div>
            <div class="info_value">
              {{ formatHourlyRate(job.recommendedRatesString) }}
            </div>
          </div>
        </div>
        <div class="info-separator mb-0" />
        <el-collapse accordion class="job-about-collapse" @change="handleChange">
          <el-collapse-item
            class="card-accordeon"
            title="More about the job"
            name="first"
          >
            <div class="collapse-list more-info">
              <div class="collapse-item">
                <span class="collapse-title"
                  >Hourly Rate (excluding super)</span
                >
                <span class="collapse-value">
                  {{ formatHourlyRate(job.recommendedRatesString) }}
                </span>
              </div>
              <div v-if="job.settings.language" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">{{ job.settings.language }}</span>
              </div>

              <div class="collapse-item">
                <span class="collapse-title"
                  >COVID {{ message.Immuniser }} req?</span
                >
                <span class="collapse-value">{{
                  job.covidCertRequired == 0
                    ? "Not Required"
                    : job.covidCertRequired == 1
                    ? "Mandatory"
                    : "Nice to Have"
                }}</span>
              </div>

              <div class="collapse-item">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>

              <div class="collapse-item">
                <span class="collapse-title">Pay for Travel</span>
                <span class="collapse-value">{{
                  payingForTravelText(job.settings.payingForTravel)
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payingForTravel == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accommodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccommodation == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item" v-if="isAustralia">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                  job.settings.adminAids == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.openUp == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.close == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Notes</span>
                <p class="job-notes__content">{{ job.settings.notes }}</p>
              </div>
              <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Parking</span>
                <p class="job-notes__content">{{ job.settings.parking }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="info-separator mt-0" />
      </div>
      <el-form
        class="job_shifts_wrapper full_page"
        :model="formsData.dayForm"
        :rules="formsData.dayForm.rules"
        :ref="(el) => (formsData.dayForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="submit('dayForm')"
      >
        <div class="d-flex justify-content-between mb-2 align-items-center">
          <div class="text-locumate-secondary fs-18 font-weight-600">
            Shifts
          </div>
          <el-button type="primary" round size="sm" @click="SelectAllShifts">
            Select All Shifts
          </el-button>
        </div>
        <div v-if="job.isBlockShift == 0">
          <div
            class="form_text"
            v-if="formsData.dayForm.jobShifts.value.length >= 2"
          >
            <div class="text_note">Deselect days you do not wish to work</div>
          </div>
        </div>
        <div
          v-else-if="
            job.isBlockShift == 1 &&
            formsData.dayForm.jobShifts.value.length >= 2
          "
        >
          <div class="form_text">
            <div class="text_note">
              Important: This is a bulk shift. The pharmacy requests a single
              locum to book all listed shifts. Individual shift bookings are not
              available.
            </div>
          </div>
        </div>
        <div
          v-else-if="
            job.isBlockShift == 1 &&
            formsData.dayForm.jobShifts.value.length <= 1
          "
        ></div>

        <div
          class="job_shifts_form_checkbox"
          v-for="(shift, i) in formsData.dayForm.jobShifts.value"
          :key="shift.date"
        >
          <el-form-item class="mb0" prop="jobShifts">
            <el-checkbox
              :disabled="shift.disabled"
              class="checkbox_w100"
              v-model="shift.checkboxValue"
              @change="checkboxValueChange(shift.checkboxValue)"
            >
              <div
                :class="shift.confirmedHours ? 'confirmedHours' : ''"
                class="job_shift_text"
              >
                <div class="day_info">
                  <div class="day_name">
                    {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                    {{
                      $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMM, YYYY")
                    }}
                  </div>
                  <div class="day_time">
                    <span>{{
                      $moment(shift.startTime, "HH:mm").format("h:mm A")
                    }}</span>
                    -
                    <span>{{
                      $moment(shift.endTime, "HH:mm").format("h:mm A")
                    }}</span>
                    <span v-if="showShiftInformation(shift)">
                      ({{
                        confirmedHours(
                          shift.confirmedHours,
                          shift.startTime,
                          shift.endTime
                        )
                      }}
                      Hours)</span
                    >
                  </div>
                </div>
                <div class="info-wrapper">
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name">Hourly Rate</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Rate(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <RoutingIcon />
                    <div
                      class="title"
                      v-if="
                        job.settings.payingForTravel == 3 &&
                        job.maxTravelCompensation !== 0
                      "
                    >
                      <span>Capped Travel</span>
                    </div>
                    <div class="title" v-else>
                      <span>Travel</span>
                    </div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        <span>{{ travelCompensationCount(job, shift) }}</span>
                      </span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="day_info_block">
                    <DollarWithCircleIcon />
                    <div class="day_name">Sum</div>
                    <div class="day_time">
                      <span v-if="showShiftInformation(shift)">
                        {{ Sum(shift) }}</span
                      >
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-checkbox>
            <template #error="{ error }">
              <div
                class="error_list"
                v-if="
                  error ||
                  (formsData.dayForm.jobShifts.errors &&
                    formsData.dayForm.jobShifts.errors[i])
                "
              >
                <div
                  class="el-form-item__error"
                  :class="
                    formsData.dayForm.jobShifts.errors &&
                    formsData.dayForm.jobShifts.errors[i]
                      ? ''
                      : 'form_error'
                  "
                >
                  <span
                    v-if="
                      error &&
                      job.isBlockShift !== 1 &&
                      !formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.value.length - 1 == i
                    "
                    >{{ error }}</span
                  >
                  <span
                    v-if="
                      error &&
                      job.isBlockShift == 1 &&
                      !formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.value.length - 1 == i
                    "
                    >Please select all days</span
                  >
                  <span
                    v-if="
                      formsData.dayForm.jobShifts.errors &&
                      formsData.dayForm.jobShifts.errors[i]
                    "
                    >{{ formsData.dayForm.jobShifts.errors[i].message }}</span
                  >
                </div>
              </div>
              <span v-else></span>
            </template>
          </el-form-item>
        </div>
        <el-form-item prop="jobShiftsErrors" class="button_submit mb0">
          <el-button class="submit_page" type="grey" @click="goNext">
            Calendar View
          </el-button>
          <el-button
            class="submit_page"
            type="blue"
            @click="dialogVisible = true"
            :disabled="formsData.dayForm.disabled"
          >
            Mark as Filled
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class="el_dialog_wraper agency-dialog">
    <el-dialog v-model="dialogVisible" class="el-message-box" @closed="resetFulfillForm">
      <div className="agency-modal">
        <h2 class="confirmation-title">Mark the shift as fulfilled</h2>
        <p style="font-size: 1.1rem" class="confirmation-para">
          Please fill the form below to mark the shift as filled.
        </p>
      </div>
      <!-- Add el-form inside the el-dialog -->
      <el-form
        class="confirmation-form"
        ref="form"
        :model="fulfillFormData"
        :rules="rules"
      >
        <!-- First Name -->
        <el-form-item label="First Name" prop="first_name">
          <el-input v-model="fulfillFormData.first_name"></el-input>
        </el-form-item>
        <!-- Last Name -->
        <el-form-item label="Last Name" prop="last_name">
          <el-input v-model="fulfillFormData.last_name"></el-input>
        </el-form-item>
        <!-- Rate -->
        <el-form-item 
          label="Rate (excluding super)" 
          prop="rate"
          v-if="formsData.dayForm.jobShifts.value.some(shift => {
            const d = new Date(shift.date).getDay();
            return d !== 0 && d !== 6 && shift.checkboxValue;
          })"
        >
          <div style="display: flex; flex-direction: column; width: 100%;">
            <small><span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
              Rate should be within the range of {{ formatMinMaxRate(job.minRate) }} to {{ formatMinMaxRate(job.maxRate) }}
            </span></small>
            <small v-if="rateDecimalIncomplete.rate">
              <span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                Please enter up to 2 digits after the decimal point (e.g. 90.50) or remove the decimal.
              </span>
            </small>
            <el-input
              v-model="fulfillFormData.rate"
              @input="handleRateInput('rate', $event)"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="Weekend Rate (excluding super)"
          prop="weekend_rate"
          v-if="(isSaturdayShift || isSundayShift) && (job.weekendMinRate !== 0 && job.weekendMaxRate !== 0)"
        >
          <div style="display: flex; flex-direction: column; width: 100%;">
            <small><span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
              Rate should be within the range of {{ formatMinMaxRate(job.weekendMinRate) }} to {{ formatMinMaxRate(job.weekendMaxRate) }}
            </span></small>
            <small v-if="rateDecimalIncomplete.weekend_rate">
              <span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                Please enter up to 2 digits after the decimal point (e.g. 90.50) or remove the decimal.
              </span>
            </small>
          <el-input
            v-model="fulfillFormData.weekend_rate"
            @input="handleRateInput('weekend_rate', $event)"
          ></el-input>
          </div>
        </el-form-item>
        <div v-if="job.weekendMinRate == 0 && job.weekendMaxRate == 0">
          <el-form-item
            label="Saturday Rate (excluding super)"
            prop="saturday_rate"
            v-if="isSaturdayShift"
          >
            <div style="display: flex; flex-direction: column; width: 100%;">
              <small><span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                Rate should be within the range of {{ formatMinMaxRate(job.saturdayMinRate) }} to {{ formatMinMaxRate(job.saturdayMaxRate) }}
              </span></small>
              <small v-if="rateDecimalIncomplete.saturday_rate">
                <span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                  Please enter up to 2 digits after the decimal point (e.g. 90.50) or remove the decimal.
                </span>
              </small>
              <el-input
                v-model="fulfillFormData.saturday_rate"
                @input="handleRateInput('saturday_rate', $event)"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="Sunday Rate (excluding super)"
            prop="sunday_rate"
            v-if="isSundayShift"
          >
            <div style="display: flex; flex-direction: column; width: 100%;">
              <small><span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                Rate should be within the range of {{ formatMinMaxRate(job.sundayMinRate) }} to {{ formatMinMaxRate(job.sundayMaxRate) }}
              </span></small>
              <small v-if="rateDecimalIncomplete.sunday_rate">
                <span style="color: #F56C6C; font-size: 12px; margin-bottom: 4px;">
                  Please enter up to 2 digits after the decimal point (e.g. 90.50) or remove the decimal.
                </span>
              </small>
              <el-input
                v-model="fulfillFormData.sunday_rate"
                @input="handleRateInput('sunday_rate', $event)"
              ></el-input>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span
          class="dialog-footer"
          style="display: flex; width: 100%; justify-content: center; gap: 1rem"
        >
          <el-button @click="dialogVisible = false" style="width: 100px"
            >Cancel</el-button
          >
          <el-button
            class="submit_page"
            type="blue"
            @click="submit('dayForm')"
            :disabled="isFormInvalid"
            style="width: 100px"
            >Save</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>

  <modal-user-info
    :modalName="'userInfoModal'"
    :options="userInfoModal"
  ></modal-user-info>
</template>

<script>
import { ElMessage } from "@/components/Vendor/Element";
import "./AgencyDays.scss";
import moment from "moment";

import { ref, onBeforeMount, onMounted, inject, nextTick, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { isAustraliaRegion } from "@/helpers/region/regionHelper.js";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import { UserInfoModal } from "@/modals/modals";
import timeDiff from "@/helpers/date/timeDiff";
import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
import { ElMessageBox } from "@/components/Vendor/Element";
import store from "@/store/store";
import ClockIcon from "@/components/Icons/ClockIcon.vue";
import DollarWithCircleIcon from "@/components/Icons/DollarWithCircleIcon.vue";
import LocationIcon from "@/components/Icons/LocationIcon.vue";
import RoutingIcon from "@/components/Icons/RoutingIcon.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    "modal-user-info": UserInfoModal,
    ClockIcon,
    DollarWithCircleIcon,
    LocationIcon,
    RoutingIcon
  },
  directives: {},

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();
    const dialogVisible = ref(false);
    const currentUrl = process.env.VUE_APP_CURRENT_URL;
    const isAustralia = isAustraliaRegion();

    const setPageClassGlobal = inject("setPageClassGlobal");
    const $modals = inject("$modals");
    const googleMaps = inject(["googleMaps"]);
    const message = inject("messages");

    let job = ref($store.getters.getJobDetails.job);
    console.log("🚀 ~ file: AgencyDays.vue:425 ~ setup ~ job:", job);
    let shifts = ref(job.value.shifts);

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;

    const payingForTravelText = (payingForTravel) => {
      if (payingForTravel === 0) {
        return "No Travel";
      } else if (payingForTravel === 1) {
        return "Partial Travel";
      } else if (payingForTravel === 2) {
        return "Full Travel";
      } else if (payingForTravel === 3) {
        return "Capped Travel";
      }

      // Default value if none of the conditions match
      return "Unknown";
    };

    const fulfillFormData = ref({
      first_name: '',
      last_name: '',
      rate: '',
      weekend_rate: '',
      saturday_rate: '',
      sunday_rate: '',
    });

    const resetFulfillForm = () => {
      fulfillFormData.value = {
        first_name: '',
        last_name: '',
        rate: '',
        weekend_rate: '',
        saturday_rate: '',
        sunday_rate: '',
      };
      form.value?.clearValidate();
    };

    const form = ref();
    const rules = {
      first_name: [
        { required: true, message: "First Name is required", trigger: "blur" },
        {
          type: "string",
          message: "First Name must be a string",
          trigger: "blur",
        },
      ],
      last_name: [
        { required: true, message: "Last Name is required", trigger: "blur" },
        {
          type: "string",
          message: "Last Name must be a string",
          trigger: "blur",
        },
      ],
      rate: [
        { required: true, message: "Rate is required", trigger: "blur" },
        {
          type: "number",
          message: "Rate must be a number",
          trigger: "blur",
          validator: (rule, value) => {
            if (typeof value === "string" && value.endsWith(".")) {
              return "Please enter digits after the decimal point or remove the decimal.";
            }
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) {
              return "Rate must be a number";
            }
            // Check if it has at most 2 decimal places
            if ((numericValue * 100) % 1 !== 0) {
              return "Rate can have at most 2 decimal places";
            }

            if(numericValue < job.value.minRate || numericValue > job.value.maxRate){
              return `Rate should be within the range of ${formatMinMaxRate(job.value.minRate)} to ${formatMinMaxRate(job.value.maxRate)}`;
            }
            
            return true;
          },
        },
      ],
      weekend_rate: [
        {
          required: true,
          message: "Weekend Rate is required",
          trigger: "blur",
        },
        {
          type: "number",
          message: "Weekend must be a number",
          trigger: "blur",
          validator: (rule, value) => {
            if (typeof value === "string" && value.endsWith(".")) {
              return "Please enter digits after the decimal point or remove the decimal.";
            }
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) {
              return "Weekend must be a number";
            }
            // Check if it has at most 2 decimal places
            if ((numericValue * 100) % 1 !== 0) {
              return "Weekend can have at most 2 decimal places";
            }
            if(!value){
              return "Weekend Rate is required";
            }
            return true;
          },
        },
      ],
      saturday_rate: [
        {
          required: true,
          message: "Saturday Rate is required",
          trigger: "blur",
        },
        {
          type: "number",
          message: "Rate must be a number",
          trigger: "blur",
          validator: (rule, value) => {
            if (typeof value === "string" && value.endsWith(".")) {
              return "Please enter digits after the decimal point or remove the decimal.";
            }
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) {
              return "Rate must be a number";
            }
            // Check if it has at most 2 decimal places
            if ((numericValue * 100) % 1 !== 0) {
              return "Rate can have at most 2 decimal places";
            }
            return true;
          },
        },
      ],
      sunday_rate: [
        { required: true, message: "Sunday Rate is required", trigger: "blur" },
        {
          type: "number",
          message: "Rate must be a number",
          trigger: "blur",
          validator: (rule, value) => {
            if (typeof value === "string" && value.endsWith(".")) {
              return "Please enter digits after the decimal point or remove the decimal.";
            }
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) {
              return "Rate must be a number";
            }
            // Check if it has at most 2 decimal places
            if ((numericValue * 100) % 1 !== 0) {
              return "Rate can have at most 2 decimal places";
            }
            return true;
          },
        },
      ],
    };
    const handleRateInput = (fieldName, value) => {
      const raw = String(value ?? "");
      // Keep only digits and dots
      let cleanValue = raw.replace(/[^0-9.]/g, "");

      // If it starts with '.', normalize to '0.'
      if (cleanValue.startsWith(".")) {
        cleanValue = `0${cleanValue}`;
      }

      // Keep only the first dot, strip any extras
      const firstDotIdx = cleanValue.indexOf(".");
      if (firstDotIdx !== -1) {
        const before = cleanValue.slice(0, firstDotIdx);
        const after = cleanValue.slice(firstDotIdx + 1).replace(/\./g, "");
        cleanValue = `${before}.${after}`;
      }

      // Ensure that the input is not zero
      if (cleanValue === "0") {
        cleanValue = "";
      }

      // Limit the number of digits before the decimal point to three
      const parts = cleanValue.split(".");
      if (parts[0].length > 3) {
        parts[0] = parts[0].substring(0, 3);
      }

      // Limit the number of decimal places to two (but allow trailing '.' while typing)
      if (parts.length === 2) {
        parts[1] = (parts[1] ?? "").substring(0, 2);
        cleanValue = `${parts[0]}.${parts[1]}`;

        // Preserve trailing '.' if user just typed it (i.e. raw ends with '.')
        if (raw.trim().endsWith(".") && parts[1].length === 0) {
          cleanValue = `${parts[0]}.`;
        }
      } else {
        cleanValue = parts[0];
      }

      fulfillFormData.value[fieldName] = cleanValue;
    };

    const showWeekendRateInput = computed(
      () =>
        (isSaturdayShift.value || isSundayShift.value) &&
        job.value.weekendMinRate !== 0 &&
        job.value.weekendMaxRate !== 0
    );
    const showSaturdayRateInput = computed(
      () =>
        isSaturdayShift.value &&
        job.value.weekendMinRate == 0 &&
        job.value.weekendMaxRate == 0
    );
    const showSundayRateInput = computed(
      () =>
        isSundayShift.value &&
        job.value.weekendMinRate == 0 &&
        job.value.weekendMaxRate == 0
    );

    const rateDecimalIncomplete = computed(() => {
      const endsWithDot = (v) => typeof v === "string" && v.trim().endsWith(".");
      return {
        rate: hasWeekdayShift.value && endsWithDot(fulfillFormData.value.rate),
        weekend_rate:
          showWeekendRateInput.value && endsWithDot(fulfillFormData.value.weekend_rate),
        saturday_rate:
          showSaturdayRateInput.value && endsWithDot(fulfillFormData.value.saturday_rate),
        sunday_rate:
          showSundayRateInput.value && endsWithDot(fulfillFormData.value.sunday_rate),
      };
    });
    const hasAnyIncompleteDecimal = computed(() =>
      Object.values(rateDecimalIncomplete.value).some(Boolean)
    );

    const isFormInvalid = computed(() => {
      const { first_name, last_name, rate, weekend_rate, saturday_rate, sunday_rate } = fulfillFormData.value;

      if (hasAnyIncompleteDecimal.value) return true;

      // Check base conditions for form validity
      const hasBasicInfo = first_name && last_name;

      //NOTE : (!hasWeekdayShift.value || (rate && Number(rate) > 0))
      //Added the above line of code because if the form has weekday shifts selected then rate should be provided and greater than 0

      // Scenarios
      //Check if only weekend day shifts and weekend rate is within range
      const isWeekendShiftValid = isSaturdayShift.value && isSundayShift.value && hasBasicInfo && weekend_rate && checkIfWeekendRateIsValid(weekend_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0)); 
      const isWeekendButOnlySaturdayShiftValid = isSaturdayShift.value && !isSundayShift.value && hasBasicInfo && weekend_rate && checkIfWeekendRateIsValid(weekend_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0));     
      const isWeekendButOnlySundayShiftValid = !isSaturdayShift.value && isSundayShift.value && hasBasicInfo && weekend_rate && checkIfWeekendRateIsValid(weekend_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0));
      //Check if both weekend and weekday shifts are selected and rates are within range
      const isBothShiftsValid = checkBothWeekendAndWeekdaysShift() && hasBasicInfo && rate && weekend_rate && checkIfRateIsValid(rate) && checkIfWeekendRateIsValid(weekend_rate);
      //Check if only weekday shifts are selected and rate is within range
      const isWeekdayShiftValid = !isSaturdayShift.value && !isSundayShift.value && hasBasicInfo && rate && checkIfRateIsValid(rate);
      //Checks if saturday and sunday shifts are selected and if saturday and sunday has it's own rates and within range
      const isSaturdayAndSundayShiftValid = hasBasicInfo && !rate && saturday_rate && sunday_rate && checkIfSaturdaySundayRateIsValid(saturday_rate, sunday_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0));
      //check if only saturday shifts are selected and saturday rate is within range
      const isSaturdayOnlyShiftValid = isSaturdayShift.value && !isSundayShift.value && hasBasicInfo && !rate && saturday_rate && checkIfSaturdayRateIsValid(saturday_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0));
      //check if only sunday shifts are selected and sunday rate is within range
      const isSundayOnlyShiftValid = !isSaturdayShift.value && isSundayShift.value && hasBasicInfo && !rate && sunday_rate && checkIfSundayRateIsValid(sunday_rate) && (!hasWeekdayShift.value || (rate && Number(rate) > 0));
      //Check if weekday shifts and saturday shifts are selected and if saturday has it's own rates and within range
      const isWeekDayAndSaturdayShiftValid = isSaturdayShift.value && !isSundayShift.value && hasBasicInfo && rate && saturday_rate && checkIfRateIsValid(rate) && checkIfSaturdayRateIsValid(saturday_rate);
      //Check if weekday shifts and sunday shifts are selected and if sunday has it's own rates and within range
      const isWeekDayAndSundayShiftValid = !isSaturdayShift.value && isSundayShift.value && hasBasicInfo && rate && sunday_rate && checkIfRateIsValid(rate) && checkIfSundayRateIsValid(sunday_rate);
      //Check if weekday shifts and saturday and sunday shifts are selected and if saturday and sunday has it's own rates and within range
      const isWeekDayAndSaturdaySundayShiftValid = hasBasicInfo && rate && saturday_rate && sunday_rate && checkIfRateIsValid(rate) && checkIfSaturdaySundayRateIsValid(saturday_rate, sunday_rate);

      // Form is invalid if none of the conditions are met
      return !(isWeekendShiftValid || isBothShiftsValid || isWeekdayShiftValid || isSaturdayAndSundayShiftValid || isWeekDayAndSaturdaySundayShiftValid 
      || isSaturdayOnlyShiftValid || isSundayOnlyShiftValid || isWeekDayAndSaturdayShiftValid || isWeekDayAndSundayShiftValid || isWeekendButOnlySaturdayShiftValid || isWeekendButOnlySundayShiftValid);
    });

    // shifts.value.forEach((shift) => {
    //   moment().diff(
    //     moment(shift.date + " " + shift.startTime, "YYYY/MM/DD HH:mm:ss"),
    //     "minutes"
    //   ) <= 0
    //     ? (shift.disabled = false)
    //     : (() => {
    //         shift.disabled = true;
    //         shift.checkboxValue = false;
    //       })();

    //   if (shift.userId) {
    //     shift.disabled = true;
    //     shift.checkboxValue = false;
    //   }

    //   if (shift.abilities) {
    //     const isAssignAvailable = shift.abilities["assign"] == true;

    //     shift.disabled = isAssignAvailable ? false : true;
    //     shift.checkboxValue = isAssignAvailable ? true : false;
    //   }

    //   if (shift.checkboxValue == undefined) {
    //     shift.checkboxValue = true;
    //   }
    // });

    const formsDataArray = {
      dayForm: {
        jobShifts: {
          value: shifts.value,
          errors: null,
          validators: [
            {
              validator: (rule, formField, callback) => {
                let errors = formsData.dayForm.jobShifts.errors;
                let formName = formField.formName;

                // console.log(errors);

                if (!errors || !errors.length) {
                  setFormValidation(formName, rule.field, true);
                  callback();
                } else {
                  setFormValidation(formName, rule.field, false);
                  callback(new Error(""));
                }
              },
            },
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "jobShiftsBook",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    (async () => {
      try {
        if (!job.value.distance) {
          let needToRetrieveDistance = true;
          let jobsDistancesCache = store.getters.getJobDistancesData.length
            ? store.getters.getJobDistancesData
            : []; // data from cache

          for (let cacheItem of jobsDistancesCache) {
            if (cacheItem.id == job.value.pharmacyId && cacheItem.cachedAt) {
              //check if distance exists in cache
              console.log("distance item loaded from cache");
              console.log(cacheItem.distance);

              needToRetrieveDistance = false;
              job.value.distance = cacheItem.distance;
              break;
            }
          }

          if (needToRetrieveDistance) {
            const result = await googleMaps.getDistance(userData.address, [
              job.value.pharmacy.address,
            ]);

            let distance = null;
            let jobDistance = result[0].elements[0].distance
              ? result[0].elements[0].distance.text
              : null;

            if (jobDistance) {
              jobDistance = jobDistance.replace(",", ".");
              if (new RegExp("(.*)(km|км)$", "gm").test(jobDistance)) {
                distance = parseFloat(jobDistance);
              } else if (new RegExp("(.*)(m|м)$", "gm").test(jobDistance)) {
                distance = parseFloat(jobDistance) / 1000;
              } else {
                console.log("");
              }
            }

            job.value.distance = distance;
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();
    const SelectAllShifts = () => {
      // Determine if all enabled shifts are already checked
      const allChecked = formsData.dayForm.jobShifts.value.every(
        (shift) => shift.disabled || shift.checkboxValue === true
      );

      // Set the checkboxValue for each shift accordingly
      formsData.dayForm.jobShifts.value.forEach((shift) => {
        if (!shift.disabled) {
          shift.checkboxValue = !allChecked;
        }
      });
    };
    const checkboxValueChange = (value) => {
      if (job.value.isBlockShift == 1) {
        formsData.dayForm.jobShifts.value.forEach((shift) => {
          if (value) {
            shift.checkboxValue = true;
          } else {
            shift.checkboxValue = false;
          }
        });
        nextTick(() => {
          checkFormValidation("dayForm", true);
        });
      } else {
        if (formsData.dayForm.jobShifts.errors) {
          delete formsData.dayForm.jobShifts.errors;
        }
        nextTick(() => {
          checkFormValidation("dayForm", true);
        });
      }
      checkWeekendShiftAvailable();
    };

    const isSaturdayShift = ref(false);
    const isSundayShift = ref(false);
    let days = [];
    
    const checkWeekendShiftAvailable = (ismounted = false) => {
      isSundayShift.value = false;
      isSaturdayShift.value = false;

      formsData.dayForm.jobShifts.value.forEach((shift) => {
        const date = new Date(shift.date); // Assuming `shift.date` is in a valid date format
        const day = date.getDay(); // 0 for Sunday, 6 for Saturday

        //push day value into days array
        days.push(day);
        
        if (
          (day === 0 && shift.checkboxValue) ||
          (day === 0 && ismounted && !shift.disabled)
        ) {
          isSundayShift.value = true;
        }

        if (
          (day === 6 && shift.checkboxValue) ||
          (day === 6 && ismounted && !shift.disabled)
        ) {
          isSaturdayShift.value = true;
        }

      });
    };

    //if contains 0 and 6 with other days return true
    //if contains only 0 or 6 return false
    const checkBothWeekendAndWeekdaysShift = () => {
      return days.some(day => day !== 0 && day !== 6);
    };

    const checkIfRateIsValid = (rate) => {
      if(rate >= job.value.minRate && rate <= job.value.maxRate){
        return true;
      }

      return false;
    };

    const checkIfWeekendRateIsValid = (weekendRate) => {
      if(weekendRate >= job.value.weekendMinRate && weekendRate <= job.value.weekendMaxRate){
        return true;
      }

      return false;
    };

    const checkIfSaturdaySundayRateIsValid = (saturdayRate, sundayRate) => {

      if((saturdayRate >= job.value.saturdayMinRate && saturdayRate <= job.value.saturdayMaxRate) &&
         (sundayRate >= job.value.sundayMinRate && sundayRate <= job.value.sundayMaxRate)){
        return true;
      }

      return false;
    };

    const checkIfSaturdayRateIsValid = (saturdayRate) => {
      if(saturdayRate >= job.value.saturdayMinRate && saturdayRate <= job.value.saturdayMaxRate){
        return true;
      }

      return false;
    };

    const checkIfSundayRateIsValid = (sundayRate) => {
      if(sundayRate >= job.value.sundayMinRate && sundayRate <= job.value.sundayMaxRate){
        return true;
      }

      return false;
    };


    const hasWeekdayShift = computed(() =>
      formsData.dayForm.jobShifts.value.some(shift => {
        const d = new Date(shift.date).getDay();
        return d !== 0 && d !== 6 && shift.checkboxValue;
      })
    );

    
    const showShiftInformation = (shift) => {
      if (!shift.userId) return true;
      if (shift.userId === userData.id) return true;
      return false;
    };

    const checkJobDateStart = (dateStart, endDate, trim) => {
      let start = moment(dateStart, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
      let end = moment(endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
      if (start.format("MMMM") == end.format("MMMM")) {
        if (start.format("D") == end.format("D")) {
          return null;
        }
        return start.format("D ");
      } else {
        return start.format("D " + (trim ? "MMM" : "MMMM"));
      }
    };

    const getSelectedShiftsId = () => {
      return shifts.value
        .filter((day) => {
          if (day.checkboxValue == true) {
            return true;
          }
        })
        .map((day) => day.id);
    };

    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const userInfoModalOpen = () => {
      userInfoModal.value.user = job.value.pharmacy;
      $modals.open("userInfoModal");
    };

    const goBack = () => {
      goToSearch();
    };

    const goToSearch = () => {
      $router.push({ name: "search" });
    };

    const goNext = async () => {
      await $store.dispatch("setJobDetails", { job: job.value });
      $router.push({ name: "job_book_calendar" });
    };

    const submit = (formName) => {
      // console.log("🚀 ~ file: AgencyDays.vue:formNgetSelectedShiftsId", getSelectedShiftsId())
      // console.log("🚀 ~ file: AgencyDays.vue:first_name", fulfillFormData.value.first_name)
      // console.log("🚀 ~ file: AgencyDays.vue:last_name", fulfillFormData.value.last_name)
      // console.log("🚀 ~ file: AgencyDays.vue:rate", fulfillFormData.value.rate)

      formsRefs[formName].value.validate((valid) => {
        console.log("checking validation", valid);
        if (valid) {
          (async () => {
            try {
              await $store.dispatch("FULFILLED_JOB_SHIFTS", {
                shifts_ids: getSelectedShiftsId(),
                first_name: fulfillFormData.value.first_name,
                last_name: fulfillFormData.value.last_name,
                rate: fulfillFormData.value.rate,
                weekend_rate: fulfillFormData.value.weekend_rate,
                saturday_rate: fulfillFormData.value.saturday_rate,
                sunday_rate: fulfillFormData.value.sunday_rate,
                min_rate: job.value.minRate,
                max_rate: job.value.maxRate,
                weekend_min_rate: job.value.weekendMinRate,
                weekend_max_rate: job.value.weekendMaxRate,
                saturday_min_rate: job.value.saturdayMinRate,
                saturday_max_rate: job.value.saturdayMaxRate,
                sunday_min_rate: job.value.sundayMinRate,
                sunday_max_rate: job.value.sundayMaxRate,
                // saturday_rate: fulfillFormData.value.saturday_rate,
                // sunday_rate: fulfillFormData.value.sunday_rate,
              });
              ElMessage({
                type: "success",
                message:
                  "Thank You!, Your shifts have been fulfilled successfully",
              });
              $router.push({
                name: "search",
              });
              // if (!job.value.collaboratedBefore)
              //   $router.push({
              //     name: "chat_message",
              //     params: {
              //       chatId: `${job.value.pharmacyId}.${userData.id}`,
              //       firstCollaborate: true,
              //     },
              //   });
            } catch (error) {
              let errorMessage = [];
              shifts.value.filter((shift) => {
                let errorsArray = error.errors.some((element) => {
                  if (element.id == shift.id) {
                    errorMessage.push({
                      date: shift.date,
                      message: element.message,
                    });
                    return true;
                  }
                });
                if (!errorsArray) errorMessage.push(null);
              });
              console.log(errorMessage);
              formsData.dayForm.jobShifts.errors = errorMessage;
              checkFormValidation("dayForm", true);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    onBeforeMount(async () => {
      return new Promise((resolve) => {
        $store
          .dispatch("GET_JOB_INFO", {
            jobId: route.params.jobId,
            params: {
              with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
            },
          })
          .then((response) => {
            let jobFetchResult = response.data;

            if (jobFetchResult.error) {
              ElMessage({
                type: "error",
                message: jobFetchResult.message,
              });
              goToSearch();

              return;
            }

            job.value = jobFetchResult;
            console.log(jobFetchResult);
            if (jobFetchResult.blacklistedByPharmacy) {
              goToSearch();
            }
            job.value.distance = jobFetchResult.distance;
            shifts.value = jobFetchResult.shifts;
            shifts.value.forEach((shift) => {
              moment().diff(
                moment(
                  shift.date + " " + shift.startTime,
                  "YYYY/MM/DD HH:mm:ss"
                ),
                "minutes"
              ) <= 0
                ? (shift.disabled = false)
                : (() => {
                    shift.disabled = true;
                    shift.checkboxValue = false;
                  })();

              if (shift.userId) {
                shift.disabled = true;
                shift.checkboxValue = false;
              }
              if (shift.agencyId) {
                shift.disabled = true;
                shift.checkboxValue = false;
              }

              if (shift.abilities) {
                const isAssignAvailable = shift.abilities["assign"] == true;

                shift.disabled = isAssignAvailable ? false : true;
                shift.checkboxValue = isAssignAvailable ? true : false;
              }

              if (shift.checkboxValue == undefined) {
                shift.checkboxValue = true;
              }
            });

            // formsData.dayForm.jobShifts.value = shifts.value;
            // Ensure the properties are present and reactive
            formsData.dayForm.jobShifts.value = shifts.value;
            checkWeekendShiftAvailable(true);
            resolve(response);
          });
      });
    });
    // let jobFetchResult = await $store.dispatch("GET_JOB_INFO", {
    //     jobId: job.value.id,
    //     params: {
    //       with: "shift_availability_stats,pharmacy,pharmacy.settings,pharmacy.address,shifts,shifts.abilities,settings",
    //     }
    // })
    // console.log('FETCH RESULT', jobFetchResult)
    // job.value.distance = jobFetchResult.data.distance
    // shifts.value =  job.value.shifts
    // console.log('JOB', job)
    // console.log('SHIFTS', shifts.value)

    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      setFormRefs();
      checkFormValidation("dayForm", true);
    });

    const formatHourlyRate = (regularRate) => {
      let formattedString = "";
      let parseRate = parseFloat(regularRate.replace("$", ""));
      if (parseRate) {
        formattedString += formatCurrency(parseRate);
      }

      return formattedString;
    };
    const formatCurrency = (rate) => {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(rate);
    };

    const handleChange = (e) => {
      e.stoppropagation();
    };
    const confirmedHours = (confirmedHours, startTime, endTime) => {
      let hours = 0;
      if (confirmedHours == 0 || confirmedHours == null) {
        const start = moment(startTime, "HH:mm:ss");
        const end = moment(endTime, "HH:mm:ss");

        hours = timeDiff(start, end);
      } else {
        const string = String(confirmedHours);
        const numHours = string.split(".")[0];
        let minutes = string.split(".")[1];

        if (!minutes) {
          const time = numHours + ":" + "00";
          hours = String(time);
        } else {
          minutes = Number.parseFloat(`0.${minutes}`) * 60;
          hours = numHours + ":" + minutes.toFixed(0);
        }
      }

      return hours;
    };
    const Sum = (shift) => {
      console.log("🚀 ~ file: AgencyDays.vue:882 ~ Sum ~ shift:", shift);
      // function add(accumulator, a) {
      //   // eslint-disable-line no-unused-vars

      //   return +accumulator + a;
      // }

      let Sum;
      let confirmedHoursVal;
      let payRate;
      let travelCompensation = 0;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      if (userRole === "agency") {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          payRate = shift.recommendedRate;
        } else {
          payRate = shift.payRateExecSuper;
        }
      } else {
        payRate = shift.payRateExecSuper;
      }

      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      if (
        shift.travelCompensation === 0 &&
        shift.adminUpdatedTravelCompensation == false
      ) {
        let jobDistance = shift.distance ? shift.distance : null;
        console.log(
          "🚀 ~ file: AgencyDays.vue:918 ~ Sum ~ jobDistance:",
          jobDistance
        );

        if (jobDistance === null && job.value.distance) {
          jobDistance = job.value.distance;
          console.log(
            "🚀 ~ file: AgencyDays.vue:922 ~ Sum ~ jobDistance:",
            jobDistance
          );
        }

        let distance = jobDistance;
        console.log(
          "🚀 ~ file: AgencyDays.vue:926 ~ Sum ~ distance:",
          distance
        );

        if (job.value.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            travelCompensation =
              (distance * 2 - 50) * globalTravelCompensationValue;
          } else {
            // travelCompensation = shift.travelCompensation;
            travelCompensation = 0;
          }
        } else if (job.value.settings.payingForTravel == 2) {
          travelCompensation = distance * 2 * globalTravelCompensationValue;
        } else if (
          job.value.settings.payingForTravel === 3 &&
          job.value.maxTravelCompensation !== 0
        ) {
          let realTravelCost = distance * 2 * globalTravelCompensationValue;
          if (realTravelCost > job.value.maxTravelCompensation) {
            travelCompensation = job.value.maxTravelCompensation;
          } else {
            travelCompensation = distance * 2 * globalTravelCompensationValue;
          }
        }

        // if (!shift.travelCompensation) {

        //   if (jobDistance) {

        //     if (job.value.settings.payingForTravel == 1) {
        //       if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         // travelCompensation = shift.travelCompensation;
        //         travelCompensation = 0;
        //       }
        //     } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        //   }
        // } else {
        //   if (job.value.settings.payingForTravel == 1) {
        //   if (distance * 2 > 50) {
        //         travelCompensation =
        //           (distance * 2 - 50) * globalTravelCompensationValue;
        //       } else {
        //         travelCompensation = 0;
        //       }
        //        } else if (job.value.settings.payingForTravel == 2) {
        //       travelCompensation = distance * 2 * globalTravelCompensationValue;
        //     }
        // }

        if (!job.value.settings.payingForTravel) {
          travelCompensation = 0;
        }
      } else {
        travelCompensation = shift.travelCompensation;
      }

      Sum = payRate * confirmedHoursVal + travelCompensation;
      if (Sum != 0) {
        Sum = new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(Sum);
      } else {
        Sum = "-";
      }
      return Sum;
    };

    const Rate = (shift) => {
      console.log("🚀 ~ file: AgencyDays.vue:980 ~ Rate ~ shift:", shift);
      if (userRole === "agency") {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.recommendedRate);
        } else {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper);
        }
      }
    };

    const formatMinMaxRate = (rate) => {
      return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(rate);
    };

    const distance = (job, shift) => {
      let result;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      if (!shift.distance && !job.distance) {
        result = "-";
      } else {
        let distance;
        distance = shift.historyDistance ? shift.historyDistance : job.distance;
        if (job.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(result1);
          } else {
            result = "-";
          }
        } else if (job.settings.payingForTravel == 2) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(distance * 2 * globalTravelCompensationValue);
        } else if (job.settings.payingForTravel == 3) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(job.maxTravelCompensation);
        }
      }

      return result;
    };
    const share = () => {
      const link = currentUrl + "job-preview/" + job.value.id;
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
        type: "success",
        showCancelButton: false,
        confirmButtonText: "Close",
        callback: () => {
          console.log("btn click");
        },
      });
    };

    const travelCompensationCount = (job, shift) => {
      if (
        (shift.travelCompensation >= 0 &&
          shift.adminUpdatedTravelCompensation == true) ||
        (shift.travelCompensation === 0 &&
          shift.adminUpdatedTravelCompensation == true)
      ) {
        return `$${shift.travelCompensation}`;
      } else {
        if (
          job.settings.payingForTravel === 0 &&
          shift.adminUpdatedTravelCompensation == false
        ) {
          return "-";
        }

        if (
          job.settings.payingForTravel === 3 &&
          job.maxTravelCompensation !== 0
        ) {
          let travelCompensation;
          const globalTravelCompensationValue =
            process.env.VUE_APP_TRAVEL_COMPENSATION;
          let jobDistance;

          if (shift.distance) {
            jobDistance = shift.distance;
          } else {
            jobDistance = shift.historyDistance
              ? shift.historyDistance
              : job.distance;
          }

          if (jobDistance) {
            let distance = jobDistance;
            travelCompensation = distance * 2 * globalTravelCompensationValue;
            if (travelCompensation > job.maxTravelCompensation) {
              return `$${job.maxTravelCompensation}`;
            } else {
              travelCompensation = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(distance * 2 * globalTravelCompensationValue);
              return travelCompensation;
            }
          } else {
            return `$${job.maxTravelCompensation}`;
          }
        } else {
          return distance(job, shift);
        }
      }
    };
    const {
      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      travelCompensationCount,
      showShiftInformation,
      formatHourlyRate,
      formsData,
      handleChange,
      checkFormValidation,
      setFormValidation,
      goBack,
      goNext,
      submit,
      job,
      shifts,
      checkJobDateStart,
      checkboxValueChange,
      userInfoModalOpen,
      userInfoModal,
      Sum,
      confirmedHours,
      Rate,
      distance,
      share,
      dialogVisible,
      fulfillFormData,
      rules,
      isFormInvalid,
      form,
      handleRateInput,
      rateDecimalIncomplete,
      payingForTravelText,
      formatCurrency,
      SelectAllShifts,
      isAustralia,
      message,
      isSaturdayShift,
      isSundayShift,
      checkBothWeekendAndWeekdaysShift,
      checkIfSaturdaySundayRateIsValid,
      formatMinMaxRate,
      resetFulfillForm
    };
  },
};
</script>

<style lang="scss" scoped>
.agency-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .agency-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dialog-footer {
    button {
      flex-grow: 1;
    }
  }
}
</style>
